module.exports = __webpack_public_path__ + "img/mfmstop.4d165614.jpg";